import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const location = useLocation();
  const isLanding = location.pathname === '/';

  return (
    <footer className={`site-footer${isLanding ? ' site-footer--landing' : ''}`}>
      <div className="site-footer__inner">
        <Link className="site-footer__link" to="/terms">
          Términos y Condiciones
        </Link>
        <a className="site-footer__email" href="mailto:hola@miestampita.com">
          hola@miestampita.com
        </a>
        <a
          className="site-footer__social"
          href="https://www.instagram.com/miestampitacom"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Seguinos en Instagram"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
            <circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" />
          </svg>
        </a>
      </div>
    </footer>
  );
}
